import { render, staticRenderFns } from "./identification-information.vue?vue&type=template&id=85bec0c2&scoped=true"
import script from "./identification-information.vue?vue&type=script&lang=ts"
export * from "./identification-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bec0c2",
  null
  
)

export default component.exports